(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["playroots-color"] && !Shopify.designMode) return;
  try {
    if (!window.__playrootsImgErrorBound) {
    window.__playrootsImgErrorBound = true;
    document.addEventListener(
      'error',
      (event) => {
        const target = event.target;
        if (target instanceof HTMLImageElement) {
          target.classList.add('playroots-img-broken');
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
